// Anonymous analytics. Spec section 8.
// Only event names from ALLOWED_EVENTS may ever be sent, with no payload
// beyond the name. Never attach health, symptom or identity data.
// Provider: Plausible (cookieless) when VITE_PLAUSIBLE_DOMAIN is set;
// otherwise events are no-ops (development default).

const ALLOWED_EVENTS = [
  "qr_landing_opened",
  "home_viewed",
  "onboarding_started",
  "onboarding_completed",
  "hand_position_viewed",
  "modes_viewed",
  "session_screen_viewed",
  "session_marked_complete",
  "routine_viewed",
  "help_viewed",
  "help_article_viewed",
  "safety_viewed",
  "support_clicked",
  "pwa_installed"
] as const;

export type AnalyticsEvent = (typeof ALLOWED_EVENTS)[number];

declare global {
  interface Window {
    plausible?: (event: string) => void;
  }
}

export function track(event: AnalyticsEvent): void {
  if (!ALLOWED_EVENTS.includes(event)) return; // hard guard
  try {
    const fn = window.plausible;
    if (typeof fn === "function") fn(event);
  } catch {
    /* analytics must never break the app */
  }
}

export function initAnalytics(): void {
  const domain = import.meta.env.VITE_PLAUSIBLE_DOMAIN as string | undefined;
  if (!domain) return;
  const s = document.createElement("script");
  s.defer = true;
  s.dataset.domain = domain;
  s.src = "https://plausible.io/js/script.js";
  document.head.appendChild(s);
  window.addEventListener("appinstalled", () => track("pwa_installed"));
}
